import React from 'react';
import s from './StackedInfoItem.scss';
import {InfoSectionDescription} from '../../../InfoSectionDescription/InfoSectionDescription';
import {InfoSectionTitle} from '../../../InfoSectionTitle/InfoSectionTitle';
import {InfoSectionLayoutId} from '../../../../../constants';
import {Cell} from '../../../../Layouts/Cell/Cell';

export enum StackedInfoItemDataHook {
  Root = 'stacked-info-item',
}

export interface StackedInfoItemProps {
  description: string;
  index: number;
  title: string;
}

export class StackedInfoItem extends React.Component<StackedInfoItemProps> {
  public render(): JSX.Element {
    const {description, title, index} = this.props;

    return (
      <li className={s.container} data-hook={StackedInfoItemDataHook.Root}>
        <Cell className={s.stacked}>
          <InfoSectionTitle theme={InfoSectionLayoutId.Stacked} title={title} />
          <InfoSectionDescription description={description} index={index} />
        </Cell>
      </li>
    );
  }
}
